/* =========================================================================== *\
 __      __.__     ___________           .__    ____ ________  ________.________
/  \    /  \__| ___\__    ___/___   ____ |  |__/_   /   __   \/   __   \   ____/
\   \/\/   /  |/    \|    |_/ __ \_/ ___\|  |  \|   \____    /\____    /____  \ 
 \        /|  |   |  \    |\  ___/\  \___|   Y  \   |  /    /    /    //       \
  \__/\  / |__|___|  /____| \___  >\___  >___|  /___| /____/    /____//______  /
       \/          \/           \/     \/     \/                             \/ 
\* =========================================================================== */

import React, { useEffect, useState, useRef } from 'react';
import { useParams } from 'react-router-dom';

// @mui material components
import Icon from '@mui/material/Icon';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import TableHead from '@mui/material/TableHead';
import Grid from '@mui/material/Grid';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import Avatar from '@mui/material/Avatar';
import Paper from '@mui/material/Paper';
import TableContainer from '@mui/material/TableContainer';
import InputAdornment from '@mui/material/InputAdornment';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';

// Material Dashboard 2 PRO React components
import MDBox from 'components/MDBox';
import MDButton from 'components/MDButton';
import MDSnackbar from 'components/MDSnackbar';
import MDInput from 'components/MDInput';
import MDSelect from 'components/MDSelect';
import MDTypography from 'components/MDTypography';
import TableHeader from 'components/Table/TableHeader';
import MDDatePicker from 'components/MDDatePicker';

// Material Dashboard 2 PRO React examples
import { useTranslation } from 'react-i18next';
import { APP_STATE } from 'services/Define';
import { FetchData } from 'services/Request';
import { useSelector } from 'react-redux';
import * as Func from 'services/Function';

const initAttr = {
  id: '',
  list_id: '',
  receive_id: '',
  product_id: '',
  product_sku: '',
  product_name: '',
  product_image: '',
  price: '',
  quantity: '',
  amount: '',
  unit_id: '',
  warehouse_id: '',
  zone_id: '',
  lot: '',
  is_expire: 'N',
  date_expire: Func.dateNow(),
  created_at: '',
  updated_at: '',
};

const initFind = {
  search: '',
  order_by: 'tb.id',
  order_sort: 'asc',
  page: 1,
  perPage: 10,
  pageTotal: 0,
};

const initParent = {
  id: '',
  code: '',
  remark: '',
  type_id: '',
  supplier_id: '',
  pr_id: '0',
  pr_type: '',
  pr_date: '',
  pr_remark: '',
  pr_user: '',
  vat_type: 'NO',
  status: 'edit',
  print_url: '',
  created_at: '',
  updated_at: '',
};

function ProductionReceiveList() {
  const mod = 'production_receive_list';
  const app = useSelector((state) => state[APP_STATE]);
  const { t, i18n } = useTranslation();
  const { id } = useParams();
  const [record, setRecord] = useState([]);
  const [attr, setAttr] = useState(initAttr);
  const [find, setFind] = useState(initFind);
  const [notify, setNotify] = useState(null);
  const [confirm, setConfirm] = useState(false);
  const [loading, setLoading] = useState(true);
  const [order, setOrder] = useState(initFind.order_sort);
  const [orderBy, setOrderBy] = useState(initFind.order_by);
  const [modalAdd, setModalAdd] = useState(false);
  const [modalEdit, setModalEdit] = useState(false);
  const [modalDel, setModalDel] = useState(false);
  const [modalProduct, setModalProduct] = useState(false);
  const [modalPO, setModalPO] = useState(false);
  const [cboProduct, setCboProduct] = useState([]);
  const [cboPO, setCboPO] = useState([]);
  const [cboUnit, setCboUnit] = useState([]);
  const [cboWarehouse, setCboWarehouse] = useState([]);
  const [cboZone, setCboZone] = useState([]);
  const [parent, setParent] = useState(initParent);

  const txtSearchProduct = useRef(null);
  const txtQuantity = useRef(null);

  const initHeader = [
    { id: 'edit', label: '', align: 'center', sort: false },
    { id: 'tb.id', label: t(`attr.id`), align: 'center' },
    { id: 'pd.image_id', label: t(`attr.image`), align: 'center' },
    { id: 'tb.barcode_id', label: 'สินค้า', align: 'left' },
    { id: 'tb.quantity', label: 'จำนวน', align: 'right' },
    { id: 'tb.unit_id', label: 'หน่วย', align: 'left' },
    { id: 'tb.lot', label: 'LOT', align: 'center' },
    { id: 'tb.date_expire', label: 'วันหมดอายุ', align: 'center' },
    { id: 'delete', label: '', align: 'center', sort: false },
  ];

  const showNotify = (msg, color) => {
    setNotify(
      <MDSnackbar
        color={color}
        icon='notifications'
        title={t(`app.name`)}
        content={msg}
        dateTime={Func.dateTimeDisplay()}
        open={Boolean(true)}
        close={() => setNotify(!notify)}
      />
    );

    setTimeout(function () {
      setNotify(null);
    }, 3000);
  };

  const view = (data) => {
    setFind(data);
    setLoading(true);
    setRecord([]);

    FetchData('POST', `/${mod}`, app.token, {
      lang: app.lang,
      search: data.search,
      page: data.page,
      per_page: data.perPage,
      orderby: data.order_by,
      ordersort: data.order_sort,
      ref_id: id,
    }).then((result) => {
      if (result.status === 'ok') {
        setRecord(result.data);
        setParent(result.parent);
      }
      setLoading(false);
    });
  };

  const open = (item) => {
    setAttr({
      ...initAttr,
      id: item.id,
      price: item.price,
      quantity: item.quantity,
      amount: item.price * item.quantity,
    });
    setModalEdit(true);
    setConfirm(false);

    setTimeout(function () {
      txtQuantity.current.select();
    }, 500);
  };

  const searchPO = () => {
    setAttr(initAttr);

    FetchData('OPTIONS', `/${mod}/po`, app.token, {
      id: id,
    }).then((result) => {
      if (result.status === 'ok') {
        setCboPO(result.data);
        setModalPO(true);
        setConfirm(false);
      } else {
        Func.exitApp();
      }
    });
  };

  const productSelect = (row) => {
    setCboUnit(row.unit);
    setAttr({
      ...attr,
      list_id: '0',
      product_id: row.id,
      product_sku: row.sku,
      product_name: row.name,
      product_image: row.image,
      price: row.price,
      unit_id: row.unit_id,
    });
    setModalAdd(true);
    setModalProduct(false);
    setConfirm(false);

    setTimeout(function () {
      txtQuantity.current.focus();
    }, 500);
  };

  const searchProduct = () => {
    setAttr(initAttr);

    FetchData('OPTIONS', `/${mod}/product`, app.token, {
      search: txtSearchProduct.current.value,
    }).then((result) => {
      if (result.status === 'ok') {
        setCboProduct(result.data);
        setModalProduct(true);
        setConfirm(false);

        if (result.data.length === 1) {
          productSelect(result.data[0]);
        } else {
          setTimeout(function () {
            txtSearchProduct.current.focus();
          }, 500);
        }
      } else {
        Func.exitApp();
      }
    });
  };

  const poSelect = (row) => {
    setCboUnit(row.unit);
    setAttr({
      ...attr,
      list_id: row.id,
      product_id: row.product_id,
      product_sku: row.sku,
      product_name: row.name,
      product_image: row.image,
      quantity: row.quantity_balance,
      price: row.price,
      unit_id: row.unit_id,
    });
    setModalAdd(true);
    setModalPO(false);
    setConfirm(false);

    setTimeout(function () {
      txtQuantity.current.select();
    }, 500);
  };

  const addConfirm = () => {
    if (!Func.verifyLength(attr.product_id, 1)) return;
    if (!Func.verifyLength(attr.unit_id, 1)) return;

    setConfirm(true);
  };

  const add = () => {
    setLoading(true);
    setModalAdd(false);

    FetchData('PUT', `/${mod}`, app.token, {
      receive_id: id,
      list_id: attr.list_id,
      product_id: attr.product_id,
      quantity: attr.quantity,
      unit_id: attr.unit_id,
      warehouse_id: attr.warehouse_id,
      zone_id: attr.zone_id,
      lot: attr.lot,
      is_expire: attr.is_expire,
      date_expire: attr.date_expire,
    }).then((result) => {
      setLoading(false);

      if (result.status === 'ok') {
        view(find);
        showNotify(t(`alert.addcomplete`), 'success');
      } else {
        setModalAdd(true);
        showNotify(t(`alert.saveerror`), 'error');
      }
    });
  };

  const editConfirm = () => {
    if (!Func.verifyLength(attr.quantity, 1)) return;

    setConfirm(true);
  };

  const edit = () => {
    setLoading(true);
    setModalEdit(false);

    FetchData('PATCH', `/${mod}/${attr.id}`, app.token, {
      quantity: attr.quantity,
    }).then((result) => {
      setLoading(false);

      if (result.status === 'ok') {
        view(find);
        showNotify(t(`alert.editcomplete`), 'success');
      } else {
        setModalEdit(true);
        showNotify(t(`alert.saveerror`), 'error');
      }
    });
  };

  const del = () => {
    setLoading(true);
    setModalDel(false);

    FetchData('DELETE', `/${mod}/${attr.id}`, app.token, {}).then((result) => {
      setLoading(false);

      if (result.status === 'ok') {
        view(find);
        showNotify(t(`alert.deletecomplete`), 'success');
      } else {
        showNotify(t(`alert.deleteerror`), 'error');
      }
    });
  };

  const renderLoading = () => {
    return (
      <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loading}>
        <CircularProgress color='inherit' />
      </Backdrop>
    );
  };

  const handleSort = (e, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);

    view({ ...find, order_by: property, order_sort: isAsc ? 'desc' : 'asc' });
  };

  const imageDisplay = (item) => {
    return <Avatar alt={item.name} src={item.image} variant='rounded' />;
  };

  const expireDisplay = (item) => {
    if (item.is_expire === 'N') return '-';

    return Func.dateDisplay(item.date_expire);
  };

  const btnEdit = (item) => {
    if (parent.status !== 'edit') return null;

    return (
      <MDButton variant='text' color='success' size='small' iconOnly onClick={() => open(item)}>
        <Icon>border_color</Icon> {t(`element.edit`)}
      </MDButton>
    );
  };

  const btnDel = (item) => {
    if (parent.status !== 'edit') return null;

    return (
      <MDButton
        variant='text'
        color='error'
        size='small'
        iconOnly
        onClick={() => {
          setConfirm(false);
          setAttr(item);
          setModalDel(true);
        }}
      >
        <Icon>delete</Icon>
      </MDButton>
    );
  };

  const renderList = () => {
    return (
      <MDBox mb={3}>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <MDBox p={2}>
              <MDTypography variant='h5'>{t(`element.order`)}</MDTypography>
            </MDBox>
          </Grid>
          {parent.status !== 'edit' ? null : (
            <Grid item xs={6}>
              <MDBox display='flex' justifyContent='flex-end' gap={1} p={2}>
                <MDButton variant='outlined' color='success' onClick={() => searchPO()}>
                  <Icon>add_circle_outline</Icon>&nbsp;เพิ่มจาก PO
                </MDButton>
                <MDButton
                  variant='outlined'
                  color='info'
                  onClick={() => {
                    txtSearchProduct.current.value = '';
                    searchProduct();
                  }}
                >
                  <Icon>add_circle_outline</Icon>&nbsp;เพิ่มสินค้า
                </MDButton>
              </MDBox>
            </Grid>
          )}
          <Grid item xs={12}>
            <TableContainer sx={{ boxShadow: 0 }}>
              <Table aria-label='simple table'>
                <TableHeader
                  order={order}
                  orderBy={orderBy}
                  onRequestSort={handleSort}
                  data={initHeader}
                />
                <TableBody>
                  {record.map((row) => (
                    <TableRow key={row.id} hover>
                      <TableCell align='center' width='10'>
                        {btnEdit(row)}
                      </TableCell>
                      <TableCell align='center' width='100'>
                        {row.no}
                      </TableCell>
                      <TableCell width='40'>{imageDisplay(row)}</TableCell>
                      <TableCell>
                        <MDBox className='nowrap'>
                          {row.code} <span className='color-default'>{row.sku}</span>
                        </MDBox>
                        <MDBox className='cut' width={400}>
                          {row.name}
                        </MDBox>
                      </TableCell>
                      <TableCell align='right' width='150'>
                        {Func.numberDisplay(row.quantity)}
                      </TableCell>
                      <TableCell className='nowrap'>{row.unit_name}</TableCell>
                      <TableCell className='nowrap' align='center'>
                        {row.lot}
                      </TableCell>
                      <TableCell align='center'>{expireDisplay(row)}</TableCell>
                      <TableCell align='center' width='10'>
                        {btnDel(row)}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
        </Grid>
      </MDBox>
    );
  };

  const renderInfo = () => {
    return (
      <Grid container spacing={5}>
        <Grid item xs={6} lg={4}>
          <Paper sx={{ p: 2 }} variant='outlined'>
            {attr.product_image === '' ? null : (
              <MDBox
                component='img'
                src={attr.product_image}
                alt={attr.product_name}
                width='100%'
                height='100%'
                onClick={() => {
                  setModalAdd(false);
                  setModalEdit(false);
                  setModalProduct(true);
                }}
                sx={{ cursor: 'pointer' }}
              />
            )}
          </Paper>
        </Grid>
        <Grid item xs={6} lg={4}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <MDInput
                label='SKU'
                value={attr.product_sku}
                variant='standard'
                fullWidth
                inputProps={{
                  autoComplete: 'off',
                  readOnly: true,
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <MDInput
                label='สินค้า'
                value={attr.product_name}
                variant='standard'
                fullWidth
                inputProps={{
                  autoComplete: 'off',
                  readOnly: true,
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <MDInput
                label='จำนวน *'
                onChange={(e) => setAttr({ ...attr, quantity: e.target.value })}
                value={attr.quantity}
                variant='standard'
                type='number'
                fullWidth
                InputProps={{
                  inputRef: txtQuantity,
                  autoComplete: 'off',
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <MDSelect
                label='หน่วย *'
                labelDefault={t(`element.please_select`)}
                data={cboUnit}
                value={attr.unit_id}
                onChange={(e) => setAttr({ ...attr, unit_id: e.target.value })}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={6} lg={4}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <MDSelect
                label='คลัง'
                labelDefault={t(`element.please_select`)}
                data={cboWarehouse}
                value={attr.warehouse_id}
                onChange={(e) => {
                  setAttr({ ...attr, warehouse_id: e.target.value });

                  cboWarehouse.forEach((item, i) => {
                    if (item.id === e.target.value) {
                      setCboZone(item.zone);
                    }
                  });
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <MDSelect
                label='โซน'
                labelDefault={t(`element.please_select`)}
                data={cboZone}
                value={attr.zone_id}
                onChange={(e) => setAttr({ ...attr, zone_id: e.target.value })}
              />
            </Grid>
            <Grid item xs={12}>
              <MDInput
                label='LOT'
                onChange={(e) => setAttr({ ...attr, lot: e.target.value })}
                value={attr.lot}
                variant='standard'
                fullWidth
                InputProps={{
                  autoComplete: 'off',
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={attr.is_expire === 'Y'}
                    onChange={(e) => setAttr({ ...attr, is_expire: e.target.checked ? 'Y' : 'N' })}
                    inputProps={{
                      'aria-label': 'enable',
                    }}
                  />
                }
                label='เพิ่มวันหมดอายุ'
              />
            </Grid>
            {attr.is_expire === 'Y' ? (
              <Grid item xs={12}>
                <MDDatePicker
                  onChange={([date]) => {
                    setAttr({ ...attr, date_expire: Func.dateFormat(date) });
                  }}
                  value={new Date(attr.date_expire)}
                  input={{
                    label: 'วันหมดอายุ',
                    variant: 'standard',
                    fullWidth: true,
                  }}
                />
              </Grid>
            ) : null}
          </Grid>
        </Grid>
      </Grid>
    );
  };

  const renderPO = () => {
    return (
      <Dialog open={modalPO} maxWidth='md' keepMounted aria-describedby='dialog-pr' fullWidth>
        <DialogTitle>
          <Grid container>
            <Grid item xs={8}>
              รายการสั่งซื้อ
            </Grid>
            <Grid item xs={4}>
              <IconButton
                aria-label='close'
                onClick={() => setModalPO(false)}
                sx={{
                  position: 'absolute',
                  right: 8,
                  top: 15,
                  color: (theme) => theme.palette.grey[500],
                }}
              >
                <Icon>close</Icon>
              </IconButton>
            </Grid>
          </Grid>
        </DialogTitle>
        <DialogContent dividers sx={{ minHeight: 500 }}>
          <MDBox>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Table aria-label='pr table' size='small'>
                  <TableHead>
                    <TableRow>
                      <TableCell align='center'>รูป</TableCell>
                      <TableCell>SKU</TableCell>
                      <TableCell>สินค้า</TableCell>
                      <TableCell align='right'>จำนวน</TableCell>
                      <TableCell align='right'>รับแล้ว</TableCell>
                      <TableCell align='right'>รอรับ</TableCell>
                      <TableCell>หน่วย</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {cboPO.map((row) => (
                      <TableRow
                        hover
                        key={row.id}
                        onClick={() => poSelect(row)}
                        sx={{ cursor: 'pointer' }}
                      >
                        <TableCell width='40'>{imageDisplay(row)}</TableCell>
                        <TableCell>{row.sku}</TableCell>
                        <TableCell>{row.name}</TableCell>
                        <TableCell align='right'>{Func.numberDisplay(row.quantity)}</TableCell>
                        <TableCell align='right'>
                          {Func.numberDisplay(row.quantity_receive)}
                        </TableCell>
                        <TableCell align='right'>
                          {Func.numberDisplay(row.quantity_balance)}
                        </TableCell>
                        <TableCell>{row.unit_name}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </Grid>
            </Grid>
          </MDBox>
        </DialogContent>
      </Dialog>
    );
  };

  const renderProduct = () => {
    return (
      <Dialog
        open={modalProduct}
        maxWidth='sm'
        keepMounted
        aria-describedby='dialog-product'
        fullWidth
      >
        <DialogTitle>
          <Grid container>
            <Grid item xs={8}>
              <MDBox
                noValidate
                component='form'
                role='form'
                onSubmit={(e) => {
                  e.preventDefault();
                  searchProduct();
                }}
              >
                <MDInput
                  name='searchform'
                  fullWidth
                  InputProps={{
                    inputRef: txtSearchProduct,
                    startAdornment: (
                      <InputAdornment position='start'>
                        <span>ค้นหาสินค้า :</span>
                      </InputAdornment>
                    ),
                    autoComplete: 'off',
                  }}
                />
              </MDBox>
            </Grid>
            <Grid item xs={4}>
              <IconButton
                aria-label='close'
                onClick={() => setModalProduct(false)}
                sx={{
                  position: 'absolute',
                  right: 8,
                  top: 15,
                  color: (theme) => theme.palette.grey[500],
                }}
              >
                <Icon>close</Icon>
              </IconButton>
            </Grid>
          </Grid>
        </DialogTitle>
        <DialogContent dividers sx={{ minHeight: 500 }}>
          <MDBox>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Table aria-label='product table' size='small'>
                  <TableHead>
                    <TableRow>
                      <TableCell align='center'>รูป</TableCell>
                      <TableCell>SKU</TableCell>
                      <TableCell>สินค้า</TableCell>
                      <TableCell align='right'>คงเหลือ</TableCell>
                      <TableCell>หน่วย</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {cboProduct.map((row) => (
                      <TableRow
                        hover
                        key={row.id}
                        onClick={() => productSelect(row)}
                        sx={{ cursor: 'pointer' }}
                      >
                        <TableCell width='40'>{imageDisplay(row)}</TableCell>
                        <TableCell>{row.sku}</TableCell>
                        <TableCell>{row.name}</TableCell>
                        <TableCell align='right'>{Func.numberDisplay(row.quantity)}</TableCell>
                        <TableCell>{row.unit_name}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </Grid>
            </Grid>
          </MDBox>
        </DialogContent>
      </Dialog>
    );
  };

  const renderAdd = () => {
    return (
      <Dialog open={modalAdd} maxWidth='md' keepMounted aria-describedby='dialog-add' fullWidth>
        <DialogTitle>
          {t(`element.add`)}
          <IconButton
            aria-label='close'
            onClick={() => setModalAdd(false)}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <Icon>close</Icon>
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          <MDBox p={3}>{renderInfo()}</MDBox>
        </DialogContent>
        <DialogActions>
          {confirm ? (
            <Grid container>
              <Grid item xs={6}>
                <MDButton variant='text' color='error' onClick={() => setConfirm(false)}>
                  <Icon>cancel</Icon>&nbsp;{t(`element.cancel`)}
                </MDButton>
              </Grid>
              <Grid item xs={6} display='flex' justifyContent='flex-end'>
                <MDButton variant='outlined' color='success' onClick={add}>
                  <Icon>save</Icon>&nbsp;{t(`element.saveconfirm`)}
                </MDButton>
              </Grid>
            </Grid>
          ) : (
            <MDButton variant='text' color='info' onClick={addConfirm}>
              <Icon>save</Icon>&nbsp;{t(`element.save`)}
            </MDButton>
          )}
        </DialogActions>
      </Dialog>
    );
  };

  const renderEdit = () => {
    return (
      <Dialog open={modalEdit} maxWidth='xs' keepMounted aria-describedby='dialog-edit' fullWidth>
        <DialogTitle>
          {t(`element.edit`)} #{attr.id}
          <IconButton
            aria-label='close'
            onClick={() => setModalEdit(false)}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <Icon>close</Icon>
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          <MDBox p={3}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <MDInput
                  label='จำนวน *'
                  onChange={(e) =>
                    setAttr({
                      ...attr,
                      quantity: e.target.value,
                      amount: attr.price * e.target.value,
                    })
                  }
                  value={attr.quantity}
                  variant='standard'
                  type='number'
                  fullWidth
                  InputProps={{
                    autoComplete: 'off',
                  }}
                />
              </Grid>
            </Grid>
          </MDBox>
        </DialogContent>
        <DialogActions>
          {confirm ? (
            <Grid container>
              <Grid item xs={6}>
                <MDButton variant='text' color='error' onClick={() => setConfirm(false)}>
                  <Icon>cancel</Icon>&nbsp;{t(`element.cancel`)}
                </MDButton>
              </Grid>
              <Grid item xs={6} display='flex' justifyContent='flex-end'>
                <MDButton variant='outlined' color='success' onClick={edit}>
                  <Icon>save</Icon>&nbsp;{t(`element.saveconfirm`)}
                </MDButton>
              </Grid>
            </Grid>
          ) : (
            <MDButton variant='text' color='success' onClick={editConfirm}>
              <Icon>save</Icon>&nbsp;{t(`element.save`)}
            </MDButton>
          )}
        </DialogActions>
      </Dialog>
    );
  };

  const renderDelete = () => {
    return (
      <Dialog
        open={modalDel}
        onClose={() => setModalDel(false)}
        maxWidth='sm'
        keepMounted
        aria-describedby='dialog-delete'
      >
        <DialogTitle>
          {t(`element.delete`)} #{attr.id}
          <IconButton
            aria-label='close'
            onClick={() => setModalDel(false)}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <Icon>close</Icon>
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          <DialogContentText p={5}>{t(`alert.confirm_delete_title`)}</DialogContentText>
        </DialogContent>
        <DialogActions>
          {confirm ? (
            <Grid container>
              <Grid item xs={6}>
                <MDButton variant='text' color='error' onClick={() => setModalDel(false)}>
                  <Icon>cancel</Icon>&nbsp;{t(`element.cancel`)}
                </MDButton>
              </Grid>
              <Grid item xs={6} display='flex' justifyContent='flex-end'>
                <MDButton variant='gradient' color='error' onClick={del}>
                  <Icon>delete</Icon>&nbsp;{t(`element.deleteconfirm`)}
                </MDButton>
              </Grid>
            </Grid>
          ) : (
            <MDButton variant='text' color='error' onClick={() => setConfirm(true)}>
              <Icon>delete</Icon>&nbsp;{t(`element.delete`)}
            </MDButton>
          )}
        </DialogActions>
      </Dialog>
    );
  };

  useEffect(() => {
    i18n.changeLanguage(app.lang);

    view(find);
  }, [id]);

  return (
    <div>
      {renderList()}
      {renderAdd()}
      {renderEdit()}
      {renderDelete()}
      {renderProduct()}
      {renderLoading()}
      {notify}
    </div>
  );
}

export default ProductionReceiveList;
